import {z} from 'zod';

export const ImageProcessLayout = z.object({
	name: z.string().nonempty(),
	layout: z.string().nonempty(),
	values: z.string(),
});

export type IImageProcessLayout = z.infer<typeof ImageProcessLayout>;
